const { isNil } = require('ramda')
const moment = require('moment')

const cache = {}

function stringToMomentThatMayNeverBeMutated (dateString, format, strictParsing = false) {
  const lookupKey = dateString + format + strictParsing
  if (isNil(cache[lookupKey])) {
    cache[lookupKey] = moment(dateString, format, strictParsing)
  }
  return cache[lookupKey]
}

module.exports = stringToMomentThatMayNeverBeMutated
